import { CustomRulesSidePanelWebComponent } from './component/CustomRulesSidePanelWebComponent';

export { CustomRulesSidePanelWebComponent };
